/* unplugin-vue-components disabled */import { render } from "./vocationalEducation.vue?vue&type=template&id=1e35866a&scoped=true"
import script from "./vocationalEducation.vue?vue&type=script&lang=js"
export * from "./vocationalEducation.vue?vue&type=script&lang=js"

import "../../assets/css/init/column.less?vue&type=style&index=0&id=1e35866a&lang=less&scoped=true"
import "../../assets/css/service/service.less?vue&type=style&index=1&id=1e35866a&lang=less&scoped=true"

import exportComponent from "/Users/iwowke/Desktop/work/www/iwowke.com/src/m/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e35866a"]])

export default __exports__